import {
  INCIDENTS_CODES_ALLOWED_FOR_RESOLUTION,
  SHIPPING_STATUS_CODES,
} from "../common/constants"

const STORED_STATUS_CODES = SHIPPING_STATUS_CODES.stored.split(',')

//REVIEW
const SHIPPING_STATUS_COLOR_MAP = {
  WEB0000: 'turquoise', //Grabado
  WEB0500: 'yellow', //Recogido
  WEB1000: 'yellow', //En tránsito
  WEB1500: 'yellow', //En reparto
  WEB1600: 'red', // Incidencia en reparto
  WEB2000: 'green', //Entregado
}

export const getColorChipForStatus = status =>
  SHIPPING_STATUS_COLOR_MAP[status] ?? 'neutral'

const IN_PROGRESS_STATE = 'turquoise'
const COMPLETED_STATE = 'green'
const WITH_INCIDENT_STATE = 'primary'
const WITH_INCIDENT_STATE_SOLVABLE = 'orange'
const CANCELLED_STATE = 'red'
const UNSCHEDULED_PICK_UP = 'yellow'
const WARNING = 'yellow'

export const getColorChipForStatusState = ({
  statusCode,
  incidentCode,
  isCancelled,
  isResolved,
  isUnscheduledPickup,
}) => {
  //ÑAPA CODIGO WEB1600
  if (statusCode === 'WEB1600') {
    if (isResolved) return WITH_INCIDENT_STATE_SOLVABLE
    return WITH_INCIDENT_STATE
  }
  const hasIncident = Boolean(incidentCode)
  if (['WEB1700', 'WEB1800'].includes(statusCode) && hasIncident && INCIDENTS_CODES_ALLOWED_FOR_RESOLUTION.includes(incidentCode)) {
    if (isResolved) return WARNING
    return WITH_INCIDENT_STATE
  }
  if (['WEB1700', 'WEB1800', 'WEB1900'].includes(statusCode)) {
    return WARNING
  }
  if (isCancelled) return CANCELLED_STATE

  if (isResolved) return WITH_INCIDENT_STATE_SOLVABLE


  if (isUnscheduledPickup) return UNSCHEDULED_PICK_UP
  if (hasIncident) return WITH_INCIDENT_STATE

  return statusCode === 'WEB2000' ? COMPLETED_STATE : IN_PROGRESS_STATE
}

// Variante de getColorChipForStatusState para envíos que ya vienen con
// `tracking_info` resuelto por backend (is_incident/is_resolved/can_resolve),
// usada únicamente por el módulo de seguimiento de envíos (services/shippingsTracking,
// context/useTrackingLine). NO sustituye a getColorChipForStatusState: esa función
// se mantiene intacta porque también la usa src/services/shippingsRecording/business.js
// con envíos que no tienen tracking_info (siguen identificando la incidencia por
// código de estado crudo).
//
// Envíos "almacenados temporalmente" (WEB1700/1800/1900) pueden llegar con
// tracking_info.is_incident null/false (no es una incidencia real):
// - is_resolved true: se tratan igual que una incidencia ya resuelta
//   (naranja), independientemente de is_incident.
// - is_resolved false: se pintan en amarillo (igual que TrackingTable/
//   deriveChipColorClass), no en el color de "en curso normal" (turquesa).
export const getColorChipForTrackingState = ({
  isCancelled,
  isIncident,
  isResolved,
  isUnscheduledPickup,
  isDelivered,
  statusCode,
}) => {
  if (isCancelled) return CANCELLED_STATE
  if (isResolved) return WITH_INCIDENT_STATE_SOLVABLE
  if (isIncident) return WITH_INCIDENT_STATE
  if (STORED_STATUS_CODES.includes(statusCode)) return WARNING
  if (isUnscheduledPickup) return UNSCHEDULED_PICK_UP
  return isDelivered ? COMPLETED_STATE : IN_PROGRESS_STATE
}